<template>
  <div>
    <div class="line-arrow" v-if="type == 'arrow'">
      <div class="arrow" @click="show" v-if="!showCollapse">
        <b-row>
          <b-col sm="6" class="text-left">
            <span class="title">{{ title }}</span>
          </b-col>
          <b-col sm="6" class="text-right">
            <i class="far fa-plus"></i>
          </b-col>
        </b-row>
      </div>
      <div class="arrow" @click="hide" v-if="showCollapse">
        <b-row>
          <b-col sm="6" class="text-left">
            <span class="title">{{ title }}</span>
          </b-col>
          <b-col sm="6" class="text-right">
            <i class="far fa-minus"></i>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-collapse id="collapse-4" v-model="showCollapse" class="mt-2">
      <slot></slot>
    </b-collapse>
    <div v-if="type == 'button'">
      <b-row>
        <b-col sm="12">
          <div class="text-center">
            <Button
              v-if="!showCollapse"
              :title="buttonShow.title"
              :classIcon="buttonShow.icon"
              :type="buttonShow.type"
              size="small"
              :clicked="show"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="text-center">
            <Button
              v-if="showCollapse"
              key="hideCollapse"
              :title="buttonHide.title"
              :classIcon="buttonHide.icon"
              :type="buttonHide.type"
              size="small"
              :clicked="hide"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Button from "../forms/Button.vue";

import { mapMutations } from "vuex";

export default {
  components: { Button },
  name: "Collapse",
  props: {
    buttonShow: Object,
    buttonHide: Object,
    type: {
      type: String,
      default: "button",
    },
    title: String,
    startOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCollapse: false,
    };
  },
  created() {
    this.showCollapse = this.startOpen;
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    show() {
      let self = this;
      setTimeout(function () {
        self.showCollapse = true;
      }, 200);
      this.removeLoadingButton();
    },
    hide() {
      let self = this;
      setTimeout(function () {
        self.showCollapse = false;
      }, 200);
      this.removeLoadingButton();
    },
    removeLoadingButton() {
      this.removeLoading(["showCollapse", "hideCollapse"]);
    },
  },
};
</script>
<style scoped>
.arrow {
  font-size: 14px;
  color: #577696;
  cursor: pointer;
  margin-bottom: 10px;
}

.title {
  font-size: 16px;
  margin-left: 5px;
}

.line-arrow {
  border-top: solid 1px #dbdfe9;
  margin-top: 10px;
  padding-top: 10px;
}
</style>
